'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { cn } from '@/lib/utils';

export function AuthTabsLinks() {
  const pathname = usePathname();
  const isLogin = pathname === '/auth/login';
  const isSignup = pathname === '/auth/signup';

  return (
    <div className='grid w-full grid-cols-2 rounded-md bg-brand-soft p-1'>
      <Link
        href='/auth/signup'
        className={cn(
          'rounded-sm px-3 py-2 text-center text-sm font-medium transition-colors',
          isSignup ? 'bg-brand-green text-white' : 'text-brand-base',
        )}
      >
        Sign Up
      </Link>
      <Link
        href='/auth/login'
        className={cn(
          'rounded-sm px-3 py-2 text-center text-sm font-medium transition-colors',
          isLogin ? 'bg-brand-green text-white' : 'text-brand-base',
        )}
      >
        Sign In
      </Link>
    </div>
  );
}
